'use client';

import Link from 'next/link';

import { ClaudeLogoIcon, OpenAILogoIcon } from '@/components/icons/svgs';

import { APP_ROUTES } from '@/shared/constants/navigation';

/**
 * "Works with Claude, ChatGPT and more" pill linking to /mcp, matching the home
 * hero's. Client component because the icon module uses styled-jsx.
 */
export const WorksWithPill = () => (
	<Link
		href={APP_ROUTES.MCP}
		className="relative z-10 mt-6 flex items-center rounded-full bg-white px-3 py-1 transition-colors hover:bg-accent md:mt-7"
	>
		<p className="flex items-center gap-1 text-xs font-medium text-primary/80 md:text-sm">
			<span>Works with</span>
			<span className="inline-flex items-center gap-1">
				<ClaudeLogoIcon className="h-lh size-4 shrink-0" />
				Claude,
			</span>
			<span className="inline-flex items-center gap-1">
				<OpenAILogoIcon className="h-lh size-4 shrink-0 text-primary" />
				ChatGPT
			</span>
			<span>and more</span>
		</p>
	</Link>
);
